export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_fragment_4.82adb282.jpg";